<template>
   <div class="modal fade" id="providerModal"
     tabindex="-1" role="dialog"
     aria-labelledby="providerModalLabel">
      <div class="modal-dialog d-flex h-100" role="document">
        <div class="modal-content my-auto rounded-0 border-dark"  >
        <button  type="button" data-dismiss="modal" aria-label="Close" class="absolute bg-white px-2 rounded-pill text-red z-10" style="
            top: -5px;
            right: -5px;
            border: 1px solid gray;
        ">X</button>
          <div class="px-4 my-3">
              <h4 class="card-title mb-0 text-center text-uppercase peak-sans w-100 pb-1 pt-3" style="border-bottom:2px solid #b10000">
                  {{modalHeader}}
              </h4>
          </div><!--col-->
          <div class="col-11 mx-auto text-center" style="
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;
            grid-auto-rows: minmax(45px, auto);
            font-size:16px;
            line-height:1.4;
            ">
             <div v-for="(provider, index) in this.providers" :key="index" class="align-items-center d-flex justify-content-around peak-sans text-bold">{{provider}}</div>
          </div>
            <div class="mt-4 mb-5 text-center">
                <a href="https://shodotcom.zendesk.com/hc/en-us/articles/4604273157275-How-do-I-know-if-my-provider-participates-in-the-SHOWTIME-rebate-program" target="_blank" class="text-center peak-sans text-link text-center text-red border p-2">Don’t See Your Provider? Click here.</a>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        mounted(){
            //this.$store.dispatch('getStatuses');
        },
        data() {
            return {
                modalHeader:"PARTICIPATING PROVIDERS",
            }
          },
        computed:{
            providers(){
                return this.$store.state.providers;
            }
        }
     }
</script>
<style lang="scss" scoped>
    .text-link{
        font-size:20px;
    }
</style>
